module.exports = __webpack_public_path__ + "assets/disclaimer-chevron.d43aa6a1.svg";